
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"simplified-operation.active.<true>.toast-message":"Simplified usage mode activated.","simplified-operation.active.<false>.toast-message":"Simplified usage mode deactivated."},"de":{"simplified-operation.active.<true>.toast-message":"Vereinfachter Bedienmodus aktiviert.","simplified-operation.active.<false>.toast-message":"Vereinfachter Bedienmodus deaktiviert."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();